import * as THREE from "three";
import { ResourceID } from "../../../resource_loader/resource_id.js";
import { ResourceManager } from "../../../resource_loader/resource_manager.js";

const SHARD_TILE: number = 64;
const SHARD_SHAPES: number[][][] = [
  [ [ 0.02, -0.48 ], [ 0.12, -0.08 ], [ 0.03, 0.48 ], [ -0.09, 0.04 ] ],
  [ [ -0.42, -0.36 ], [ 0.44, -0.28 ], [ 0.08, 0.42 ] ],
  [ [ 0.0, 0.46 ], [ 0.36, 0.12 ], [ 0.24, -0.38 ], [ -0.22, -0.42 ], [ -0.34, 0.1 ] ],
  [ [ -0.05, 0.48 ], [ 0.17, -0.02 ], [ 0.0, -0.48 ], [ -0.15, -0.05 ] ],
];

export const GLASS_SHARD_IDS: ResourceID[] = [
  ResourceID.GlassShard1,
  ResourceID.GlassShard2,
  ResourceID.GlassShard3,
  ResourceID.GlassShard4,
];

export function buildAndRegisterGlassShards(): void
{
  for ( let tile = 0; tile < SHARD_SHAPES.length; tile++ )
  {
    const canvas = document.createElement( "canvas" );
    canvas.width = SHARD_TILE;
    canvas.height = SHARD_TILE;

    const ctx = canvas.getContext( "2d" )!;
    const shape = SHARD_SHAPES[tile];
    const cx = SHARD_TILE * 0.5;
    const cy = SHARD_TILE * 0.5;
    const s = SHARD_TILE * 0.92;

    ctx.save();
    ctx.translate( cx, cy );

    const trace = (): void =>
    {
      ctx.beginPath();
      ctx.moveTo( shape[0][0] * s, shape[0][1] * s );
      for ( let i = 1; i < shape.length; i++ )
        ctx.lineTo( shape[i][0] * s, shape[i][1] * s );
      ctx.closePath();
    };

    const fill = ctx.createLinearGradient( -s * 0.4, -s * 0.4, s * 0.4, s * 0.4 );
    fill.addColorStop( 0, "rgba(215, 240, 255, 0.10)" );
    fill.addColorStop( 0.45, "rgba(235, 248, 255, 0.22)" );
    fill.addColorStop( 0.62, "rgba(255, 255, 255, 0.55)" );
    fill.addColorStop( 0.75, "rgba(225, 244, 255, 0.20)" );
    fill.addColorStop( 1, "rgba(200, 232, 255, 0.12)" );

    trace();
    ctx.fillStyle = fill;
    ctx.fill();

    trace();
    ctx.lineJoin = "miter";
    ctx.strokeStyle = "rgba(255, 255, 255, 0.95)";
    ctx.lineWidth = 2.6;
    ctx.stroke();

    const a = shape[0];
    const b = shape[Math.floor( shape.length / 2 )];
    ctx.beginPath();
    ctx.moveTo( a[0] * s * 0.82, a[1] * s * 0.82 );
    ctx.lineTo( b[0] * s * 0.82, b[1] * s * 0.82 );
    ctx.strokeStyle = "rgba(255, 255, 255, 0.45)";
    ctx.lineWidth = 1.4;
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo( a[0] * s, a[1] * s );
    ctx.lineTo(
      a[0] * s + ( b[0] - a[0] ) * s * 0.22,
      a[1] * s + ( b[1] - a[1] ) * s * 0.22
    );
    ctx.strokeStyle = "rgba(255, 255, 255, 0.9)";
    ctx.lineWidth = 3.2;
    ctx.stroke();

    ctx.restore();

    const texture = new THREE.Texture( canvas );
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.minFilter = THREE.LinearFilter;
    texture.flipY = false;
    texture.needsUpdate = true;

    ResourceManager.setTexture( GLASS_SHARD_IDS[tile], texture );
  }
}
